import StyledSvg from 'icons/StyledSvg';
import { IconProps } from 'icons/types';

export const Instagram = ({ size, color, x = '0px', y = '0px', scale = 0 }: IconProps) => {
  return (
    <StyledSvg
      xmlns="http://www.w3.org/2000/svg"
      width={size || '40px'}
      height={size || '40px'}
      scale={scale || 0}
      x={x}
      y={y}
      viewBox="0 0 40 40"
      fill={color || 'currentColor'}
    >
      <path
        d="M19.991,35.315c-4.276,0-4.78-0.023-6.448-0.095c-1.301-0.043-2.585-0.307-3.798-0.781
        c-2.097-0.815-3.756-2.472-4.571-4.566c-0.457-1.215-0.703-2.498-0.728-3.795c-0.097-1.663-0.097-2.208-0.097-6.444
        c0-4.282,0.023-4.781,0.097-6.439c0.026-1.296,0.272-2.577,0.728-3.79C5.989,7.306,7.65,5.648,9.751,4.835
        c1.214-0.458,2.498-0.704,3.796-0.729c1.66-0.094,2.206-0.094,6.445-0.094c4.31,0,4.806,0.023,6.448,0.094
        c1.301,0.025,2.589,0.271,3.806,0.729c2.1,0.813,3.761,2.471,4.576,4.568c0.464,1.231,0.712,2.533,0.732,3.848
        c0.097,1.663,0.097,2.206,0.097,6.441c0,4.235-0.024,4.79-0.097,6.434c-0.026,1.299-0.273,2.583-0.73,3.799
        c-0.818,2.096-2.478,3.753-4.578,4.568c-1.216,0.455-2.501,0.701-3.799,0.727C24.787,35.315,24.243,35.315,19.991,35.315z
        M19.932,6.76c-4.251,0-4.693,0.021-6.353,0.095c-0.991,0.013-1.972,0.196-2.901,0.54c-1.372,0.524-2.457,1.604-2.988,2.971
        c-0.347,0.938-0.53,1.928-0.541,2.928c-0.092,1.682-0.092,2.123-0.092,6.338c0,4.165,0.016,4.67,0.092,6.342
        c0.016,0.99,0.198,1.97,0.541,2.898c0.531,1.367,1.617,2.445,2.988,2.969c0.928,0.347,1.91,0.529,2.901,0.54
        c1.682,0.097,2.126,0.097,6.353,0.097c4.263,0,4.705-0.021,6.351-0.097c0.991-0.012,1.973-0.195,2.902-0.54
        c1.363-0.529,2.442-1.605,2.972-2.966c0.347-0.939,0.529-1.929,0.541-2.93h0.019c0.075-1.659,0.075-2.102,0.075-6.342
        c0-4.24-0.019-4.686-0.094-6.343c-0.016-0.988-0.198-1.967-0.541-2.895c-0.529-1.363-1.607-2.441-2.972-2.971
        c-0.929-0.346-1.911-0.528-2.902-0.54C24.602,6.76,24.163,6.76,19.932,6.76z M19.991,27.649c-3.25,0.002-6.182-1.951-7.427-4.949
        c-1.245-2.998-0.56-6.45,1.738-8.745c2.297-2.296,5.753-2.984,8.757-1.743c3.003,1.241,4.962,4.166,4.963,7.412
        C28.016,24.051,24.425,27.64,19.991,27.649z M19.991,14.414c-2.88,0-5.214,2.331-5.214,5.207c0,2.875,2.334,5.207,5.214,5.207
        c2.88,0,5.214-2.331,5.214-5.207C25.199,16.748,22.868,14.42,19.991,14.414z M28.334,13.176c-1.033-0.004-1.869-0.842-1.867-1.874
        c0.002-1.032,0.84-1.867,1.874-1.867c1.033,0,1.872,0.836,1.874,1.867c0.001,0.498-0.198,0.975-0.551,1.327
        C29.311,12.981,28.833,13.178,28.334,13.176z"
        fill={color || 'currentColor'}
      />
    </StyledSvg>
  );
};
